import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { NgxSpinnerService } from "ngx-spinner";
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { setImageUrl } from '../fni-modules/shared/helper/common_function';
import { CanonicalService } from '../shared/seo/canonical.service';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { SeoService } from '../shared/seo/seo.service';
import { environment } from '../../environments/environment';
import { RootService } from '../shared/services/root.service';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { Location } from '@angular/common';
import * as $ from 'jquery'

@Component({
  selector: 'app-offer-details',
  templateUrl: './offer-details.component.html',
  styleUrls: ['./offer-details.component.scss']
})
export class OfferDetailsComponent implements OnInit {
  sub: Subscription = new Subscription();
  helpList: any;
  data: any
  currentPage: any = 1;
  totalItems: any = 0;
  itemsPerPage: any = 10;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  offerData: any = []

  isUserLoggedIn: any;
  userData: any;
  productDetailList: any;
  productDetailListvisible: boolean=false;
  metatitle: any = "Tata Motors Offers: Buy Trucks and Buses Online Now!";
  metadesc: any = "Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.";
  offeron: any = '';
  BrandcurrentPage: any;
  constructor(private apiService: ApiService, private spinner: NgxSpinnerService,
    private localStorage: secureStorage, private activatedRoute: ActivatedRoute,
    private router: Router, private seoservice: SeoService, private rootService: RootService,
    private behaviorService: BehaviourSubjectService,
    private canonicalservice: CanonicalService, private cleverService: ClevertapService,
    @Inject(PLATFORM_ID) private platformId: Object, private _location: Location) {}
  ngOnInit(): void {
    this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
      this.userData = this.rootService.getUserData();
    }));
    this.seo();
    if (isPlatformBrowser(this.platformId)) {
      this.productDetailList = JSON.parse(this.localStorage.getItem("productOfferData"))
      try {
        this.cleverService.onPageView("Offer Details");
      } catch { }
    
    this.productDetailListvisible=localStorage.getItem('isproductdetail') ? true :false
    }
    this.canonicalservice.createCanonicalURL('');
    this.getHelpList({ offset: 0, limit: 10, });
    this.breadcrumb();
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.BrandcurrentPage = params?.page
        this.getOfferDetails(params?.financierSchemeId)
      })

  }
  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag("description", null, this.metadesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      this.metatitle
    );
    this.seoservice.updateMetaTag(null, "og:description", this.metadesc);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }


  getOfferDetails(data) {
    let payload = {
      "financierSchemeId": data,
      "offset":"0",
      "state": this.userData.state ? this.userData.state : '',
      "noOfCampaignOffers": 1,
    }
    this.sub.add(
      this.apiService.getOffersDetailsNew(payload).subscribe({
        next: (res: any) => {
          this.offerData = res.offers
          if (this.offerData[0].lob != 'ALL' && this.offerData[0].lob != 'All' && this.offerData[0].lob != 'all')
            this.offeron = this.offerData[0].lob
          if (this.offerData[0].ppl != 'ALL' && this.offerData[0].ppl != 'All' && this.offerData[0].ppl != 'all')
            this.offeron = this.offerData[0].ppl
          if (this.offerData[0].vehiclePl != 'ALL' && this.offerData[0].vehiclePl != 'All' && this.offerData[0].vehiclePl != 'all')
            this.offeron = this.offerData[0].vehiclePl
          if (this.offeron == '')
            this.offeron = 'All vehicles'
          this.spinner.hide();
        },
        error: () => {},
        complete: () => {},
      })
    );

  }
  // getOfferDetails() {
  //   var json = {
  //     "pl": 'ALL',
  //     "financierName": 'financierName',
  //     "page": '1',
  //     "pageSize": '100',
  //     "sortBy": 'campaignSchemePriority',
  //     "sortOrder": 'asc'
  //   }
  //   try {
  //     this.sub.add(this.apiService.getOffersSearchDetail(json).subscribe({
  //       next: (res: any) => {

  //       },
  //       error: () => {
  //         this.ToastrService.warning('Offers api not working. Please try after sometime.')
  //       },
  //       complete: () => {
  //       }
  //     }))
  //   } catch (error) {
  //   }
  // }


  getHelpList(req: any) {
    this.spinner.show()
    this.sub.add(this.apiService.getHelpList(req).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.helpList = response["data"];
          this.totalItems = response.range_info.total_count;
          // this.productList = [...this.productList, ...response.data]
          // this.rowlimit = response.total_records
          this.spinner.hide()
          // this.CommonService.productsList = []
          // this.CommonService.productsList = this.productList
          // this.list = this.CommonService.productsList
        }
        else if (!response.success) {
          this.totalItems = 0
          // this.list = []
          // this.toastrService.warning(response.data.msg)
          this.spinner.hide()
        }
      },
      error: () => {
      },
      complete: () => {
      }
    })
    );

  }

  pageChange(page: any) {
    this.currentPage = page;
    page = page - 1;
    let reqBody =
    {
      "offset": page,
      "limit": 10
    };
    this.getHelpList(reqBody)
  }
  breadcrumb() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('localBreadCrumb');
      this.breadcrumbdata = [];
      var breadcrumbList1 = {
        label: 'Help',
        url: `/Help/`
      };
      this.breadcrumbdata.push(breadcrumbList1);
      this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbdata));
      this.showBreadCrumb = true;
    }
  }

  setFinancierImgUrl(financierId: any) {
    return setImageUrl(financierId);
  }

  gotobookNow(offerData) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.isUserLoggedIn) {
        let sublob = this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() =='icv-trucks' ? 'trucks': this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() =='buses'? 'buses-vans': this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
        let model = this.productDetailList.model
          .replace(/\s/g, '-')
          .replace(/\//g, '-')
          .replace(/\+/g, '-')
          .replace(/\./g, '-')
          ?.toLowerCase();
        this.router.navigate(['/lead-booking/' + sublob +'/' + this.offerData[0].lob +'/' +this.offerData[0].ppl + '/' + model + '/' + this.productDetailList.id]);
      } else {
        let sublob =
          this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
            'icv-trucks'
            ? 'trucks'
            : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase() ==
              'buses'
              ? 'buses-vans'
              : this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
        let model = this.productDetailList.model
          .replace(/\s/g, '-')
          .replace(/\//g, '-')
          .replace(/\+/g, '-')
          .replace(/\./g, '-')
          ?.toLowerCase();
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem(
            'previousUrl',
            '/lead-booking/' +
            sublob +
            '/' +
            this.offerData[0].lob +
            '/' +
            this.offerData[0].ppl +
            '/' +
            model +
            '/' +
            this.productDetailList.id
          );
        }
        this.router.navigate(['/login/']);
      }
      // this.clevertapBook(this.productDetailList);
    }


  }
  goBack() {
    if (isPlatformBrowser(this.platformId)) {
      this.sub.add(this.behaviorService.offerDeatil.next(this.BrandcurrentPage));
      this._location.back();
    }
  }
  goToRelatedProduct() {
   
      let sublob
      if (this.offerData[0].lob == "Pickups" || this.offerData[0].lob == "SCV Cargo") {
        sublob = 'scv-pickups'
      }

      if (this.offerData[0].lob && this.offerData[0].ppl) {
        this.router.navigate(['/product-list/' + sublob + '/' + (this.offerData[0].lob.replace(' ', '-'))?.toLowerCase() + '/' + (this.offerData[0].ppl).replace(' ', '-')?.toLowerCase()]);
      }
      if (this.offerData[0].lob && (this.offerData[0].ppl == 'ALL' || this.offerData[0].ppl == 'All' || this.offerData[0].ppl == 'all')) {
        this.router.navigate(['/category-list/' + sublob + '/' + (this.offerData[0].lob.replace(' ', '-'))?.toLowerCase()]);
      }
      if ((this.offerData[0].lob == 'ALL' || this.offerData[0].lob == 'All' || this.offerData[0].lob == 'all') && (this.offerData[0].ppl || this.offerData[0].ppl == 'ALL' || this.offerData[0].ppl == 'All' || this.offerData[0].ppl == 'all')) {
        this.router.navigate(['/home/']);
      }
    
  }
}
